export const containsHTML = (str: string) => /<[a-z][\s\S]*>/i.test(str);
